module.exports = __webpack_public_path__ + "img/cardviewicon.70976e15.svg";